module.exports = __webpack_public_path__ + "static/media/partners-2.c8d637a1.png";